export default __webpack_public_path__ + "static/media/Banner_Ronaldo.6bb6c8ba.png";